var React = require('react');

function Mouse (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7 2C4.23858 2 2 4.23858 2 7V13C2 15.7614 4.23858 18 7 18C9.76142 18 12 15.7614 12 13V7C12 4.23858 9.76142 2 7 2ZM0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7V13C14 16.866 10.866 20 7 20C3.13401 20 0 16.866 0 13V7Z","fill":"currentColor","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7 4C7.55228 4 8 4.44772 8 5V7C8 7.55228 7.55228 8 7 8C6.44772 8 6 7.55228 6 7V5C6 4.44772 6.44772 4 7 4Z","fill":"currentColor","key":1})]);
}

Mouse.defaultProps = {"width":"14","height":"20","viewBox":"0 0 14 20","fill":"none"};

module.exports = Mouse;

Mouse.default = Mouse;
